import React, { useState } from 'react';
import { api, apiError } from '../../api/client';
import { Button, Dialog, FormField } from '../ui';
import { useUI } from '../../context/UIContext';

const number = n => n?.toLocaleString('ru-RU') ?? '—';

export default function TokenQuotaCell({ user, quota, onChanged }) {
  const { confirm } = useUI();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [resetId, setResetId] = useState(null);

  const run = async action => {
    setBusy(true); setError('');
    try { await action(); await onChanged(); setOpen(false); setResetId(null); }
    catch (e) { setError(apiError(e)); }
    finally { setBusy(false); }
  };
  const reset = async () => {
    if (!await confirm(`Обнулить расход лимита пользователя «${user.display_name}» и начать новый месячный период? Денежная история сохранится.`)) return;
    const id = resetId || window.crypto.randomUUID();
    setResetId(id);
    run(() => api.resetTokenQuota(user.id, id));
  };

  return <div style={{ minWidth: 220 }}>
    <div>{quota ? quota.limit === null ? 'Без ограничений' : `${number(quota.used_tokens)} / ${number(quota.limit)}` : 'Загрузка…'}</div>
    {quota?.limit !== null && quota && <small className="text-muted">
      Доступно: {number(quota.remaining_tokens)} · В запросах: {number(quota.reserved_tokens)}<br />
      Сброс: {quota.resets_at ? new Date(quota.resets_at).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow' }) : '—'} МСК
    </small>}
    <div><Button className="btn btn-sm" disabled={!quota || busy} onClick={() => { setValue(quota.limit === null ? '' : String(quota.limit)); setError(''); setOpen(true); }}>Лимит</Button></div>
    {open && <Dialog title={`Лимит — ${user.display_name}`} onClose={() => { if (!busy) setOpen(false); }}>
      <form onSubmit={e => { e.preventDefault(); run(() => api.setTokenQuota(user.id, value === '' ? null : Number(value))); }}>
        <FormField label="Токенов в месяц" hint="Пустое поле — без ограничений. 0 — запретить новые API-вызовы. Вход и выход, включая кеш, считаются вместе.">
          <input className="form-input" type="number" min="0" max="9000000000000000" step="1" value={value} onChange={e => setValue(e.target.value)} />
        </FormField>
        <p className="text-muted">Изменение числа сохраняет расход текущего периода. Сброс начинает новый месяц от текущего момента. ACP/CLI и embeddings исключены.</p>
        {error && <p role="alert" className="alert alert-error">{error}</p>}
        <div className="flex gap-2" style={{ flexWrap: 'wrap' }}>
          <Button className="btn btn-primary" type="submit" disabled={busy}>Сохранить</Button>
          <Button className="btn" type="button" disabled={busy || quota?.limit === null} onClick={reset}>Сбросить расход</Button>
          <Button className="btn" type="button" disabled={busy} onClick={() => setOpen(false)}>Отмена</Button>
        </div>
      </form>
    </Dialog>}
  </div>;
}
